import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import LabelChipList from 'components/labels/LabelChipList';
import LabelMultiSelect from 'components/labels/LabelMultiSelect';

/**
 * The merchant list's label pieces (RAT-1690), kept out of MerchantList.jsx -
 * that file sits exactly on the 1500-line lint ceiling, so anything added there
 * has to earn its place or live here.
 */

// Column factory rather than a plain object: the caller owns the columnHelper
// instance. Roles without labels are handled by MerchantList not calling this at
// all, so the column never reaches the table for them.
export const createMerchantLabelColumn = (columnHelper) =>
  columnHelper.accessor((row) => row?.labels, {
    id: 'labels',
    header: () => (
      <Text
        align="left"
        fontSize={{ sm: '10px', lg: '12px' }}
        color="gray.400"
        whiteSpace="nowrap"
      >
        Labels
      </Text>
    ),
    // One chip plus "+N": two chips already overflow the narrowed column once a
    // merchant carries several labels, and the clipped "+N" left no hint that
    // more existed. The "+N" carries a tooltip naming the rest.
    cell: (info) => <LabelChipList labels={info.getValue()} max={1} />,
  });

// Toolbar filter. Multi-select, matching merchants that carry ANY of the
// selected labels (OR) - the picker holds an array while the URL holds a
// comma-separated string, so the conversion lives here.
//
// `show` is false for the roles labels do not exist for; the filter then renders
// nothing, so the check cannot be forgotten by a caller.
export const MerchantLabelFilter = ({ show, value, onChange }) =>
  !show ? null : (
    <Box width={{ base: '100%', sm: 'auto' }}>
      <Text
        fontSize="xs"
        fontWeight="600"
        mb="1"
        color={value.length ? 'green.500' : 'gray.400'}
      >
        Labels
      </Text>
      <LabelMultiSelect
        value={value}
        onChange={(ids) => onChange(ids.join(','))}
        placeholder="All labels"
        buttonWidth={{ base: '100%', sm: '200px' }}
        showSelectedChips={false}
      />
    </Box>
  );

MerchantLabelFilter.propTypes = {
  show: PropTypes.bool.isRequired,
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
};
